import React, { Fragment, cloneElement } from 'react';
import { classNames } from '../../utils/style';
import { ButtonCard as BtnCard } from '../ButtonCard';

export const ButtonCardMosaic = ({ className, image, button }: any) => {
  const newButton = cloneElement(button, {
    props: { ...button.props, as: 'span' },
  });
  
  return (
    <Fragment>
      <div className={classNames(`hidden md:block`, className)}>
        {image && (
          <BtnCard
            as={button.props?.as}
            href={button.props?.href}
            to={button.props?.to}
            tabIndex={button.props?.tabIndex}
            button={newButton}
            image={image}
            className="bg-white"
          />
        )}
      </div>
      <div className="inline md:hidden my-12">{button && button}</div>
    </Fragment>
  );
};
